export default "/images/youtube.png?01f0fd2cb123b05afa0bdeaba3da5f07";